import { render, staticRenderFns } from "./insurance_pay_reciept.vue?vue&type=template&id=be983cf0&scoped=true&"
import script from "./insurance_pay_reciept.vue?vue&type=script&lang=js&"
export * from "./insurance_pay_reciept.vue?vue&type=script&lang=js&"
import style0 from "./insurance_pay_reciept.vue?vue&type=style&index=0&id=be983cf0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be983cf0",
  null
  
)

export default component.exports